import script from "./PatientIntakeQualifyPatient.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientIntakeQualifyPatient.vue?vue&type=script&setup=true&lang=js"

import "./PatientIntakeQualifyPatient.vue?vue&type=style&index=0&id=70705548&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70705548"]])

export default __exports__